import { store } from '../store';
import { setCuenta, doneFrmTerceroCuentasTmp, doneRptCtasDetalles, doneRptCtasDetallesMes, doneRptCtasDetallesDia, doneFrmLogin, doneFrmConsulta, setProcesos } from '../actions'

//autoCompletar
import { setCodProcesoLst, setMagistradoLst, setDemandanteLst, setDemandadoLst, setInstanciaLst, setAccionLst, setDescriptorLst, setRestrictorLst, setDecisionLst } from '../actions'


import { setTerceroCuentas, setContadorDetalle, setContadorDetalleMes, setContadorDetalleDia, openSnackBar, openConfirmSnackBar } from '../actions'
import { sendPost, setPost } from '../actions'

import { setEditarProvidencia } from '../actions'

import { setAuthLogin } from '../actions'


export const getJson = (url) => fetch(url).then(v => v.json());

export const apiGetLogin = (url) => () =>
    fetch(url)
        .then(v => v.json())
        .then(r => {
            store.dispatch(doneFrmLogin());
            //debugger;

            if (r.cod === "1") {
                //alert(r.msg);
                store.dispatch(openSnackBar('Bienvenido(a) ' + r.usuario.nombre));
                store.dispatch(setAuthLogin(r.usuario));

                return r;
            }
            else {
                //alert(r.msg);
                store.dispatch(openConfirmSnackBar(r.msg));
                return r;
            }
        });

export const apiGetProcesos = (url) => () =>
    fetch(url)
        .then(v => v.json())
        .then(r => {
            store.dispatch(doneFrmConsulta());
            store.dispatch(setProcesos([]));
            if (r.cod === "1") {
                //alert(r.msg);
                store.dispatch(openSnackBar('Cargando resultados...'));
                store.dispatch(setProcesos(r));

                return r;
            }
            else {
                //alert(r.msg);
                store.dispatch(openConfirmSnackBar(r.msg));

                return r;
            }

        });

export const apiGetProcesosCod = (url) => () =>
    fetch(url)
        .then(v => v.json())
        .then(r => {
            if (r.cod === "1") {
                //alert(r.msg);

                //store.dispatch(setProcesos(r));

                store.dispatch(setEditarProvidencia(r.Procesos[0]));
                //debugger;
                return r;
            }
            else {
                //alert(r.msg);

                //store.dispatch(setProcesos([]));
                return r;
            }

        });

export const apiGetCodProceso = (url) => () => fetch(url)
    .then(v => v.json())
    .then(r => {
        if (r.cod === "1") {

            store.dispatch(setCodProcesoLst(r));
            return r;
        }
        else {
            //alert(r.resp);
            store.dispatch(setCodProcesoLst(r));
            return r;
        }

    });

export const apiGetMagistrado = (url) => () => fetch(url)
    .then(v => v.json())
    .then(r => {
        if (r.cod === "1") {

            store.dispatch(setMagistradoLst(r));
            return r;
        }
        else {
            //alert(r.resp);
            store.dispatch(setMagistradoLst(r));
            return r;
        }

    });

export const apiGetDemandante = (url) => () => fetch(url)
    .then(v => v.json())
    .then(r => {
        if (r.cod === "1") {

            store.dispatch(setDemandanteLst(r));
            return r;
        }
        else {
            //alert(r.resp);
            store.dispatch(setDemandanteLst(r));
            return r;
        }

    });
export const apiGetDemandado = (url) => () => fetch(url)
    .then(v => v.json())
    .then(r => {
        if (r.cod === "1") {

            store.dispatch(setDemandadoLst(r));
            return r;
        }
        else {
            //alert(r.resp);
            store.dispatch(setDemandadoLst(r));
            return r;
        }

    });
export const apiGetInstancia = (url) => () => fetch(url)
    .then(v => v.json())
    .then(r => {
        if (r.cod === "1") {

            store.dispatch(setInstanciaLst(r));
            return r;
        }
        else {
            //alert(r.resp);
            store.dispatch(setInstanciaLst(r));
            return r;
        }

    });
export const apiGetAccion = (url) => () => fetch(url)
    .then(v => v.json())
    .then(r => {
        if (r.cod === "1") {

            store.dispatch(setAccionLst(r));
            return r;
        }
        else {
            //alert(r.resp);
            store.dispatch(setAccionLst(r));
            return r;
        }

    });
export const apiGetDescriptor = (url) => () => fetch(url)
    .then(v => v.json())
    .then(r => {
        if (r.cod === "1") {

            store.dispatch(setDescriptorLst(r));
            return r;
        }
        else {
            //alert(r.resp);
            store.dispatch(setDescriptorLst(r));
            return r;
        }

    });
export const apiGetRestrictor = (url) => () => fetch(url)
    .then(v => v.json())
    .then(r => {
        if (r.cod === "1") {

            store.dispatch(setRestrictorLst(r));
            return r;
        }
        else {
            //alert(r.resp);
            store.dispatch(setRestrictorLst(r));
            return r;
        }

    });
export const apiGetDecision = (url) => () => fetch(url)
    .then(v => v.json())
    .then(r => {
        if (r.cod === "1") {

            store.dispatch(setDecisionLst(r));
            return r;
        }
        else {
            //alert(r.resp);
            store.dispatch(setDecisionLst(r));
            return r;
        }

    });


export const apiGetCtasTercero = (url) => () =>
    fetch(url)
        .then(v => v.json())
        .then(r => {
            if (r.cod === "1") {
                store.dispatch(setTerceroCuentas(r));
                return r;
            }
            else {
                alert(r.msg);
                return r;
            }

        });

export const apiGetContadorDetalle = (url) => () =>
    fetch(url)
        .then(v => v.json())
        .then(r => {
            if (r.cod === "1") {
                store.dispatch(setContadorDetalle(r));

                store.dispatch(doneFrmTerceroCuentasTmp());
                store.dispatch(doneRptCtasDetalles());
                return r;
            }
            else {
                alert(r.msg);
                return r;
            }

        });

export const apiGetContadorDetalleMes = (url) => () =>
    fetch(url)
        .then(v => v.json())
        .then(r => {
            store.dispatch(doneRptCtasDetallesMes());
            if (r.cod === "1") {
                store.dispatch(setContadorDetalleMes(r));
                return r;
            }
            else {
                alert(r.msg);
                return r;
            }
        });


export const apiGetContadorDetalleDia = (url) => () =>
    fetch(url)
        .then(v => v.json())
        .then(r => {
            if (r.cod === "1") {
                store.dispatch(setContadorDetalleDia(r));

                store.dispatch(doneRptCtasDetallesDia());
                return r;
            }
            else {
                alert(r.msg);
                return r;
            }

        });


export const apiGetCta = (url) => () => fetch(url)
    .then(v => v.json())
    .then(r => {
        if (r.resp === "ok") {
            //alert(r.resp);
            //alert("facturaNo: " + r.facturaNo + "\ncuenta: " + r.cuenta + "\ndoc: " + r.doc + "\nnombre: " + r.nombre + "\ntelefono: " + r.telefono + "\ncorreo: " + r.correo + "\nsaldo: " + r.saldo);
            store.dispatch(setCuenta(r));
            return r;
        }
        else {
            alert(r.resp);
            store.dispatch(setCuenta(r));
            return r;
        }

    });

export const apiPost = (url, obj) => () =>

    fetch(`${url}`, {
        method: 'POST',
        body: obj,
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        })
    })
        .then(v => v.json())
        .then(r => {
            store.dispatch(setPost(r));
            if (r.cod === "1") {
                //alert(r.msg);
                store.dispatch(openSnackBar(r.msg));
                return r;
            }
            else {
                //alert(r.msg);
                store.dispatch(openConfirmSnackBar(r.msg));
                return r;
                //return Promise.reject(r.msg);
            }


        });


